import React from 'react';
import TextField from '../../../../components/forms/TextField';

interface ImmediateTransferCallerNumbersManagerProps {
    value: string;
    onChange: (value: string) => void;
    onBlur: () => void;
    fieldContainerStyle?: string;
}

const ImmediateTransferCallerNumbersManager: React.FC<ImmediateTransferCallerNumbersManagerProps> = ({
    value,
    onChange,
    onBlur,
    fieldContainerStyle
}) => {
    const handleChange = (e: React.ChangeEvent<any>) => {
        onChange(e.target.value);
    };

    const handleBlur = (e: React.FocusEvent<any>) => {
        const normalized = (e.currentTarget.value ?? '')
            .split(',')
            .map((n: string) => n.trim())
            .filter((n: string) => n.length > 0)
            .join(', ');
        onChange(normalized);
        onBlur();
    };

    return (
        <TextField
            name="immediateTransferCallerNumbers"
            label="Immediate Transfer Caller Numbers"
            tooltip='Make sure to enter the transfer number above in "Default Transfer Phone Number" -- Enter the phone numbers that will be immediately transferred when they call. Separate multiple numbers with commas (e.g. 15551234567, 15559876543).'
            toolTipPosition="right"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="e.g. 15551234567, 15559876543"
            fieldContainerStyle={fieldContainerStyle}
        />
    );
};

export default ImmediateTransferCallerNumbersManager;
